import React from "react";
import PropTypes from "prop-types";

export function PlayerSearch({ value, setTypeaheadInput }) {
    return (
        <div className="ledger-search">
            <span className="ledger-search-icon" aria-hidden="true">⌕</span>
            <input
                type="search"
                className="ledger-search-input"
                placeholder="Filter players"
                value={value}
                onChange={(e) => setTypeaheadInput(e.target.value || "")}
                aria-label="Filter players by name"
            />
            {value && (
                <button
                    type="button"
                    className="ledger-search-clear"
                    aria-label="Clear filter"
                    onClick={() => setTypeaheadInput("")}
                >
                    ×
                </button>
            )}
        </div>
    );
}

PlayerSearch.propTypes = {
    value: PropTypes.string,
    setTypeaheadInput: PropTypes.func,
};
